import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import LogoIcon from '../../../../../../icons/LogoIcon';
import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerLogoControlsButton = ({ className, active, onClick }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<LogoIcon />}
      title="Logo"
      onClick={onClick}
    />
  );
};

CardDesignerLogoControlsButton.propTypes = propTypes;

export default CardDesignerLogoControlsButton;
